const enDigiLockerApaarModal = {
    "modal_title": "Sign Up",

    // Left Panel (DigiLocker)
    "left_panel_title": "Already have an APAAR / ABC ID?",
    "left_panel_subtitle": "If you already have an APAAR / ABC ID, follow these steps to register using DigiLocker:",
    "has_apaar_step1": "Click Sign Up with DigiLocker.",
    "has_apaar_step2": "Log in using your Aadhaar-linked Mobile No.",
    "has_apaar_step3": "Allow DigiLocker to share your APAAR details.",
    "has_apaar_step4": "Return automatically to complete registration.",
    "btn_signup_digilocker": "Sign Up with DigiLocker",

    // Right Panel (ABC Portal)
    "right_panel_title": "Don't have an APAAR / ABC ID?",
    "right_panel_subtitle": "If you do not have an APAAR / ABC ID, follow these steps to create one:",
    "no_apaar_step1": "Click the Proceed to ABC Portal button below.",
    "no_apaar_step2": "Sign in using your Aadhaar-linked Mobile No.",
    "no_apaar_step3": "Complete the APAAR / ABC ID generation process on the ABC Portal.",
    "no_apaar_step4": "Return to this portal after your APAAR / ABC ID has been generated.",
    "no_apaar_step5": "Continue with your DigiLocker",
    "btn_continue_abc": "Continue with ABC Portal",


};

export default enDigiLockerApaarModal;